// Libraries

// Layouts

// Components
import {
    Table,
    TableFilter,
    Popup,
    CreateUserForm,
    UserEditViewForm,
    UserMakerView,
    BreadCrumb,
} from '../../components';
import PendingVerification from '../RoleManagement/PendingVerification';

// Constants
import {
    USER_STATUS_UPDATED,
    USER_LEVEL,
} from '../../utils/constants/commonValues';

// Actions
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    fetchUserRequest,
    getAllRolesRequest,
    getUserMakersDetailsRequest,
} from './redux/userManagement.actions';
import { useHistory, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
// Styles
import './userManagement.scss';

const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {},
    },
    {
        fieldType: 'input',
        label: 'Created By',
        name: 'createdBy',
        props: {
            placeholder: 'Enter Name',
        },
    },
    {
        fieldType: 'input',
        label: 'Role',
        name: 'role',
        props: {
            placeholder: 'Enter Name',
        },
    },
    {
        fieldType: 'select',
        label: 'User Level',
        name: 'userLevel',
        props: {
            data: (function() {
                const options = [];
                for (const key in USER_LEVEL) {
                    if (Object.prototype.hasOwnProperty.call(USER_LEVEL, key)) {
                        const value = USER_LEVEL[key];
                        options.push({
                            name: value,
                            value: key,
                        });
                    }
                }
                return options;
            })(),
            label: 'Select User Level',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'select',
        label: 'Status',
        name: 'status',
        props: {
            data: (function() {
                const options = [];
                for (const key in USER_STATUS_UPDATED) {
                    if (
                        Object.prototype.hasOwnProperty.call(
                            USER_STATUS_UPDATED,
                            key
                        )
                    ) {
                        const value = USER_STATUS_UPDATED[key];
                        options.push({
                            name: value,
                            value: key,
                        });
                    }
                }
                return options;
            })(),
            label: 'Select status',
            labelField: 'name',
            valueField: 'value',
        },
    },
];

const UserManagementActions = ({ data, fetchData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const { original } = data;
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData({
                pageIndex: 1,
                pageSize: 10,
            });
            resetPage();
        }
    };
    return (
        <div className="userAction  multiItem">
            <button
                className="edit"
                onClick={() => handleOpenActionPopup('edit')}
            />
            <button
                className="view"
                onClick={() => handleOpenActionPopup('view')}
            />
            <Popup
                title={original.name}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={original}
                closePopup={handleCloseOpenActionPopup}
            >
                <UserEditViewForm
                    actionType={actionType}
                    data={original}
                    initialValues={original}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const UserManagementActionsMaker = ({ data, fetchData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);

    const { original } = data;
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData({
                pageIndex: 1,
                pageSize: 10,
                status: 'UNDER_APPROVAL',
            });
            resetPage();
        }
    };
    return (
        <div className="userAction multiItem">
            <button
                className="view"
                onClick={() => handleOpenActionPopup('view')}
            />
            <Popup
                title={original.name}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={original}
                closePopup={handleCloseOpenActionPopup}
            >
                <UserMakerView
                    actionType={actionType}
                    data={original}
                    initialValues={original}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const UserManagement = props => {
    const {
        userManagementData,
        actions,
        loader: { showLoader },
    } = props;

    const {
        error,
        tableData,
        makerData,
        makerPagination,
        isLoading,
        pagination,
    } = userManagementData;

    useEffect(() => {
        actions.getAllRolesRequest();
    }, [actions]);

    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [isResetPage, setIsResetPage] = useState(false);

    const handleCreateUser = () => {
        setShowFilter(true);
    };

    const handleCloseCreateUser = () => {
        setShowFilter(false);
    };

    const columns = useMemo(
        () => [
            { header: 'User Name', accessor: 'name' },
            { header: 'Email', accessor: 'email' },
            { header: 'Created Date', accessor: 'userCreatedDate' },
            { header: 'Created By', accessor: 'userCreatedByName' },
            { header: 'Status', accessor: 'userStatus' },
            { header: 'Role', accessor: 'userRoleName' },
            { header: 'User Level', accessor: 'userLevel' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pendingColumns = useMemo(
        () => [
            { header: 'User Name', accessor: 'name' },
            { header: 'Email', accessor: 'email' },
            { header: 'Date', accessor: 'userCreatedDate' },
            {
                header: 'Request User',
                accessor: 'userCreatedUpdatedName',
            },
            { header: 'Request Type', accessor: 'lastActions' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageSizeMaker, setPageSizeMaker] = useState(10);
    const [pageCountMaker, setPageCountMaker] = useState(0);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = {
                pageSize,
                pageIndex,
            };
            actions.fetchUserRequest({ ...data, ...filterData });
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const fetchDataMaker = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const request = {
                resultPerPage: pageSize,
                page: pageIndex,
                status: 'UNDER_APPROVAL',
            };
            actions.getUserMakersDetailsRequest(request);
            setPageSizeMaker(pageSize);
        },
        [actions]
    );

    useEffect(() => {
        if (makerPagination) {
            setPageCountMaker(
                Math.ceil(makerPagination.totalNumberOfRecords / pageSizeMaker)
            );
        } else {
            setPageCountMaker(0);
        }
    }, [makerPagination, makerPagination.totalNumberOfRecords, pageSizeMaker]);

    const history = useHistory();

    const handleBackClick = () => {
        history.push('/usermanagement');
    };

    return (
        <div className="user-management-wrapper">
            <Switch>
                <Route exact path="/usermanagement">
                    <Table
                        tableTitle="User Management"
                        filterActionTitle="Create User"
                        columns={columns}
                        isFiltersEnable
                        isPaginationEnable
                        data={tableData}
                        filterData={filterData}
                        error={error && error.errorMessage}
                        loading={showLoader || isLoading}
                        pageCount={pageCount}
                        fetchData={fetchData}
                        numberOfRecord={pagination.totalNumberOfRecords}
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        onClickTableAction={handleCreateUser}
                        pagePerView={3}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        userActions={data => (
                            <UserManagementActions
                                data={data}
                                fetchData={fetchData}
                                resetPage={() => setIsResetPage(true)}
                            />
                        )}
                        additionalActions={props => (
                            <PendingVerification
                                url="/usermanagement/pending"
                                {...props}
                            />
                        )}
                        tableFilters={
                            <TableFilter
                                showOverlay
                                fieldsList={filterFieldList}
                                onSubmit={filterValues => {
                                    setFilterData(filterValues);
                                    setIsResetPage(true);
                                }}
                                onReset={resetValue => {
                                    setFilterData(resetValue);
                                    setIsResetPage(true);
                                }}
                            />
                        }
                        tableActionPopup={
                            <Popup
                                title="CREATE USER"
                                showCloseIcon
                                showOverlay
                                showFilter={showFilter}
                                closePopup={handleCloseCreateUser}
                            >
                                <CreateUserForm fetchData={fetchData} />
                            </Popup>
                        }
                    />
                </Route>
                <Route exact path="/usermanagement/pending">
                    <Table
                        tableTitle="User Management"
                        filterActionTitle=""
                        columns={pendingColumns}
                        isFiltersEnable
                        isPaginationEnable
                        data={makerData}
                        error={error && error.errorMessage}
                        loading={showLoader || isLoading}
                        pageCount={pageCountMaker}
                        fetchData={fetchDataMaker}
                        numberOfRecord={
                            (makerPagination &&
                                makerPagination.totalNumberOfRecords) ||
                            0
                        }
                        pageSizeOptions={pageSizeOptions}
                        paginationLabel="Rows per page"
                        pagePerView={3}
                        isResetPage={isResetPage}
                        afterResetPage={() => setIsResetPage(false)}
                        userActions={data => (
                            <UserManagementActionsMaker
                                data={data}
                                fetchData={fetchData}
                                resetPage={() => setIsResetPage(true)}
                            />
                        )}
                        tableSubSection={props => (
                            <BreadCrumb
                                {...props}
                                withBack
                                wrapperClass="pendingVerification-section"
                                onBackClick={handleBackClick}
                                title="Pending Verification"
                                breadCrumbs={[
                                    {
                                        name: 'Access Management',
                                        link: '/usermanagement',
                                    },
                                    {
                                        name: 'User Management',
                                        link: '',
                                    },
                                ]}
                            />
                        )}
                    />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = ({ auth, userManagementData, loader }) => ({
    auth,
    userManagementData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            fetchUserRequest,
            getUserMakersDetailsRequest,
            getAllRolesRequest,
        },
        dispatch
    ),
});

UserManagement.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    userManagementData: PropTypes.object,
    loader: PropTypes.object,
};

UserManagementActions.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

UserManagementActionsMaker.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
